import { useProductShellNavigationContext } from "../ProductShellNavigationContext";

export const useIsMenuGroupActive = (menuGroupId: string): boolean => {
  const { activeItems } = useProductShellNavigationContext();

  return Boolean(activeItems?.activeMenuGroupIds?.includes(menuGroupId));
};
